import crud from './crud';
import confirmEmaRepeatUpload from '../../components/chartActions/emaRepeatUploadConfirmation';

// Keep one identity for the initial attempt and the explicitly confirmed retry.
// The request is captured before the dialog opens so a choice cannot apply to
// different form values or a newly selected patient.
const emaRepeatUpload = (request) => {
  if (localStorage.getItem('m8_auto_upload_emr') !== 'EMA') return crud(request);

  const idempotencyKey = window.crypto?.randomUUID?.()
    || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const initialRequest = {
    ...request,
    retryOnUnavailable: false,
    dispatch: {
      ...request.dispatch,
      meta: { ...request.dispatch.meta, emaRepeatUploadPrompt: true },
    },
    data: { ...request.data, idempotency_key: idempotencyKey },
  };

  return async (dispatch) => {
    const result = await crud(initialRequest)(dispatch);
    const conflict = result?.response?.data;
    if (!result?.error || result.response?.status !== 409
      || conflict?.code !== 'ema_repeat_upload_confirmation_required') return result;

    const choice = await confirmEmaRepeatUpload({ canCreateTask: conflict.can_create_task === true });
    if (choice === 'cancel') return { canceled: true };

    const confirmedResult = await crud({
      ...initialRequest,
      // Only the first conflict opens a dialog. A rejected confirmed request
      // must reach callers as a real failure, even if it asks for confirmation again.
      dispatch: request.dispatch,
      data: {
        ...initialRequest.data,
        repeat_upload_action: choice,
        previous_upload_id: conflict.previous_upload_id,
      },
    })(dispatch);
    return { ...confirmedResult, repeatUploadAction: choice };
  };
};

export default emaRepeatUpload;
